import Vue from "vue";
import PageWrapper from "@/components/layout/PageWrapper";

import store from "@/store";

import "@/assets/styles/base.styl";

Vue.config.performance = true;
Vue.config.productionTip = false;

new Vue({
  el: "#layout",
  store,
  components: { PageWrapper }
});
